/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './EnergiaSolarVantagens.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function EnergiaSolarVantagens() {
  return (
    <>
      <section id="energia-solar-vantagens">
        <ContainerHome24>
          <h3 className="passo-a-passo-titulo">Por que financiar energia solar com o Santander?</h3>
          <div className="passo-a-passo-carrossel">
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              //hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <img
                      className="slide-icon"
                      src="assets/energia-solar/vantagens/ic_bank_credit.svg"
                      alt=""
                    />
                    <div className="slide-textos">
                      <p className="slide-titulo">Financie seu projeto completo</p>
                      <p className="slide-texto">
                        Possibilidade de financiar equipamentos e instalação.*
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img
                      className="slide-icon"
                      src="assets/energia-solar/vantagens/ic_payment_summary.svg"
                      alt=""
                    />
                    <div className="slide-textos">
                      <p className="slide-titulo">Mais prazo para pagar</p>
                      <p className="slide-texto">Financiamento em até 96 meses.*</p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img
                      className="slide-icon"
                      src="assets/energia-solar/vantagens/ic_schedule_spending.svg"
                      alt=""
                    />
                    <div className="slide-textos">
                      <p className="slide-titulo">Até 120 dias para começar a pagar</p>
                      <p className="slide-texto">
                        Mais tempo entre a contratação e a primeira parcela.*
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img
                      className="slide-icon"
                      src="assets/energia-solar/vantagens/ic_payment_summary.svg"
                      alt=""
                    />
                    <div className="slide-textos">
                      <p className="slide-titulo">Parceiros credenciados</p>
                      <p className="slide-texto">
                        Encontre especialistas para desenvolver e instalar seu projeto.
                      </p>
                    </div>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarVantagens;
